<template>
  <div class="group">
    <div class="member">
      <img src="../assets/images/title_hexin@2x.png" class="avatar">
      <div class="person">
        <transition >
          <div class="primary" v-show="change === 1">
            <img src="../assets/images/icon_xinmi@2x.png" class="avatar">
            <img src="../assets/images/title_xinmi@2x.png" class="NAME">
            <p class="introduce">曾任职美丽说产品VP，历任百度、抓虾Rss Reader（被豆瓣收购）、魔时网（mosh.cn），用户端产品老兵&连续创业者。</p>
          </div>
         </transition>
           <transition  >
          <div class="primary" v-show="change === 2">
            <img src="../assets/images/icon_YY@2x.png" class="avatar">
            <img src="../assets/images/title_YY@2x.png" class="NAME">
            <p class="introduce">前小米·多看阅读创始团队产品VP，资深用户产品经理。对文娱/内容有极佳商业洞察及商业化实战经验。</p>
          </div>
          </transition>
          <transition  >
          <div class="primary" v-show="change === 3">
            <img src="../assets/images/icon_liushi@2x.png" class="avatar">
            <img src="../assets/images/title_liushi@2x.png" class="CTO_NAME">
            <p class="introduce">前滴滴优点产品技术VP（创办车联网团队被滴滴收购）技术实力过硬，前百度知道架构师、前百度ODP 1.0核心成员。</p>
          </div>
          </transition>
          <div class="primary1"></div>
          <img src="../assets/images/icon_RightB@2x.png" class="right" v-if="RightImg" @mouseenter="enter('Right')" @mouseleave="leave('Right')" @click="downward">
          <img src="../assets/images/icon_Right hover@2x.png" class="right" v-else @mouseenter="enter('Right')" @mouseleave="leave('Right')" @click="downward">
          <img src="../assets/images/icon_LeftB@2x.png" class="left" v-if="LeftImg" @mouseenter="enter('left')" @mouseleave="leave('left')" @click="upward">
          <img src="../assets/images/icon_Left hover@2x.png" class="left" v-else @mouseenter="enter('left')" @mouseleave="leave('left')" @click="upward">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      change: 1,
      RightImg: true,
      LeftImg: true
    }
  },
  methods: {
    downward () {
      if (this.change === 3) {
        this.change = 1
      } else {
        this.change++
      }
    },
    upward () {
      if (this.change === 1) {
        this.change = 3
      } else {
        this.change--
      }
    },
    // enter (arg) {
    //   if (arg === 'Right') {
    //     this.RightImg = false
    //   } else {
    //     this.LeftImg = false
    //   }
    // },
    // leave (arg) {
    //   if (arg === 'Right') {
    //     this.RightImg = true
    //   } else {
    //     this.LeftImg = true
    //   }
    // }
  }
}
</script>
<style lang="less">
.group{
  height: 100%;
  overflow: hidden;
  width: 100%;
  background-color: #FFEF00;
   padding-bottom: 70px;
  .member{
    width: 50%;
    height: 90%;
    margin: 0 auto;
    text-align: center;
    padding-top: 20vh;
    min-width: 600px;
    .avatar{
      height: 9%;

    }
    .person{
      width: 100%;
      height: 100%;
      position: relative;
       min-width: 600px;
      .primary{
        width: 100%;
        height: 100%;
        min-width: 600px;
        .avatar{
           height: 45%;
           margin-top: 2vh;
        }
        .NAME{
          height:8%;
          margin-top: 20px;
          display: block;
          margin: 20px auto 0;
        }
        .CTO_NAME{
          display: block;
          height:8%;
          margin: 20px auto 0;
        }
        .introduce{
          width: 390px;
          margin: 18px auto 0;
          font-size: 14px;
          color: #252525;
        }
    }
    .right{
      width: 60px;
      height: 60px;
      position: absolute;
      top: 120px;
      right: 30px;
      bottom: 0;
      // margin: auto;
    }
    .left{
      width: 60px;
      height: 60px;
      position: absolute;
      top:120px;
      left: 30px;
      bottom: 0;
      // margin: auto;
    }
  }
}
}
.v-enter-active{
  transition: opacity 2s
}
.v-enter{
  opacity: 0;
}
.v-enter-to{
  opacity: 1;
};
// @import "../../static/Adaptive/group.less";
</style>



// WEBPACK FOOTER //
// src/components/group.vue